<template>
  <el-container class="cash-register-main">
    <!--中间内容区域-->
    <el-main>
      <el-container class="trade-main">
        <el-header v-if="$store.state.routes.systemSetting.MultiStore" height="40px">
          <div>
            <el-radio-group v-model="queryParam.storeID" @input="changeStore">
              <el-radio-button v-for="item in stores || []" :key="item.ID" :label="item.ID">{{ item.Name }}</el-radio-button>
            </el-radio-group>
          </div>
        </el-header>
        <el-header height="40px">
          <el-tabs :value="queryParam.status" type="card" @tab-click="changeTab" :disabled="listLoading == true">
            <el-tab-pane :label="queryParam.source == 'proxy' ? '待发货订单' : '待提货客户'" name="waitTake"></el-tab-pane>
            <el-tab-pane :label="queryParam.source == 'proxy' ? '已发货订单' : '已提货客户'" name="taked" v-if="!productIds"></el-tab-pane>
          </el-tabs>
          <el-form :inline="true">
            <el-form-item>
              <el-tooltip effect="dark" content="关闭：隐私模式，根据条码展示订单" placement="top-start">
                <i
                  :class="encryptView ? 'ri-eye-close-line' : 'ri-eye-line'"
                  @click="changeEncrypt()"
                  style="font-size: 30px; font-weight: normal; color: #409eff"
                />
              </el-tooltip>
            </el-form-item>
            <template v-if="!encryptView">
              <el-form-item>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholde="开始日期"
                  end-placeholde="结束日期"
                  value-format="yyyy-MM-dd"
                  class="date-range"
                  @change="getList()"
                  :clearable="false"
                  clear-icon="el-icon-error"
                  :picker-options="datePickerOptions"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <template slot="label">
                  查找<el-tooltip effect="dark" content="查找范围：客户名称、客户昵称、货号" placement="top-start">
                    <i class="el-icon-question" /> </el-tooltip
                  >：
                </template>
                <el-input
                  v-model="queryParam.searchValue"
                  :title="queryParam.searchValue"
                  :class="{ 'search-item': true }"
                  @keydown.enter.native="getList()"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="待收：">
                <el-input
                  v-model="queryParam.receivePayment"
                  placeholder="待收金额"
                  :class="{ 'search-item': true }"
                  @keydown.enter.native="getList()"
                  v-format.float
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item label="条码：" v-if="encryptView">
              <el-input
                v-model="queryParam.barcode"
                :title="queryParam.barcode"
                ref="barcode"
                :class="{ barcode: true, encrypt: encryptView }"
                @keydown.enter.native="getList()"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item v-if="queryParam.source != 'proxy'">
              <el-switch
                v-model="queryParam.isMerge"
                @change="getList()"
                inactive-text="合并"
                :class="queryParam.isMerge ? 'merge-show' : 'unmerge-show'"
              ></el-switch>
            </el-form-item>
            <el-form-item v-if="queryParam.status != 'taked'">
              <el-tooltip effect="dark" content="按接单时间升序" placement="top-start">
                <i :class="'sort-icon ' + (listSort == 'timeAsc' ? 'order-active-desc' : 'order-inactive-desc')" @click="changeListSort" />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-else>
              <el-tooltip effect="dark" content="按提货时间降序" placement="top-start">
                <i
                  :class="'sort-icon ' + (takedListSort == 'modifyTimeDesc' ? 'taked-order-active-desc' : 'taked-order-inactive-desc')"
                  @click="changeListSort"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="getList()">查询</el-button>
                <el-button plain @click="resetQuery">清空</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="danger" @click="showAddRefund">仅退货</el-button>
            </el-form-item>
          </el-form>
        </el-header>
        <el-main class="trade-list-main">
          <div
            class="trade-list"
            v-loading="listLoading || sendingFlag"
            :element-loading-text="sendingFlag ? '截图中' : '拼命加载中'"
            element-loading-spinner="el-icon-loading"
          >
            <div
              v-for="(trade, index) in trades || []"
              style="position: relative"
              :key="queryParam.source + '-' + trade.TradeIDs + '-' + index"
            >
              <!-- 右下角勾选框 -->
              <div style="position: absolute; bottom: 12px; right: 10px; display: flex; flex-direction: column; z-index: 1000">
                <el-popover popper-class="errPopper" placement="top" width="10" trigger="hover" content="截图发送失败">
                  <i v-show="trade['picSendErr']" slot="reference" class="el-icon-warning" style="margin-right: 2px; color: #f44a4a"></i>
                </el-popover>
                <el-checkbox v-model="trade['newCheck']" @click.stop.native @change="handleNewCheckToggle"></el-checkbox>
              </div>
              <el-card
                v-show="!trade.Hidden"
                shadow="hover"
                :key="queryParam.source + '-' + trade.TradeIDs + '-' + index"
                @click.native="selectTrade(trade)"
                :class="{
                  trade: true,
                  'is-active': trade.Selected,
                  multi: trade.TradeIDs.indexOf(',') > -1 || trade.RefundIDs.indexOf(',') > -1,
                  proxy: trade.IsProxy,
                }"
              >
                <div slot="header" :class="getPurchaserClass(trade)" :title="trade.PurchaserName" style="position: relative">
                  {{ trade.Num > trade.TakeNum ? '[缺]' : '' }}
                  {{ (trade.PurchaserNick ? `(${trade.PurchaserNick})` : '') + trade.PurchaserName }}
                </div>
                <div class="take-num" :title="trade.TakeNum - trade.RefundNum + '双'">双数：{{ trade.TakeNum - trade.RefundNum }}双</div>
                <div class="payment" :title="(trade.PayStatus < 2 ? trade.ReceivePayment : trade.ReceivedPayment) + '元'"
                  >{{ trade.PayStatus > 0 ? '已收：' + trade.ReceivedPayment : '待收：' + trade.ReceivePayment }}元</div
                >
                <div class="create-time">
                  {{ (queryParam.status == 'waitTake' ? trade.CreateTime : trade.TakeTime).substring(2, 16) }}
                </div>
              </el-card>
            </div>
            <el-empty style="width: 100%" v-show="trades.length == 0" description="暂无数据"></el-empty>
          </div>
        </el-main>
        <el-footer height="40px" style="padding-right: 10px; display: flex; flex-direction: row">
          <!-- 批量发送截图 -->
          <div style="width: 100%; display: flex; align-items: center">
            <el-checkbox v-model="allSelect" @change="handleAllToggle">全/反选</el-checkbox>
            <el-button :loading="sendingFlag" type="primary" plain style="margin-left: 8px" @click="handleSendPics">发送截图</el-button>
            <el-button :loading="printingFlag" type="primary" plain style="margin-left: 8px" @click="handleBatchPrint">打印小票</el-button>

            <el-popover ref="myPopover" placement="top" width="360" trigger="manual" v-model="popoverVisible" title="">
              <div style="padding-left: 5px; padding-bottom: 12px; color: #f44a4a">提示：仅推送给待提货里全部缺货目为QQ 报单的客户</div>
              <el-input v-model="sendMsg" placeholder="缺货通知内容"></el-input>
              <el-button
                type="primary"
                :loading="noticeFlag"
                style="display: block; width: fit-content; margin: 10px 0 0 auto"
                @click="sendNotice"
                >发送</el-button
              >

              <!-- 参考元素：绑定点击事件 -->
              <el-button
                class="sendNoticeBtn"
                slot="reference"
                type="primary"
                plain
                style="margin-left: 8px; cursor: pointer"
                @click="handleBatchNotice"
                >缺货通知</el-button
              >
            </el-popover>
            <el-progress
              v-show="percentageShow"
              :text-inside="true"
              :stroke-width="24"
              :percentage="sendPercentage"
              style="margin-left: 8px; width: 160px"
            ></el-progress>
          </div>
          <div style="flex-shrink: 0; width: 700px; display: flex; justify-content: end; align-items: center">
            <template v-if="queryParam.source != 'proxy'">
              <el-popover placement="top" width="160" trigger="click" title="">
                <el-switch style="margin-right: 15px; padding-bottom: 8px" v-model="exportSpec" active-text="导出规格"> </el-switch>
                <el-switch style="margin-right: 15px" v-model="exportIsMerge" active-text="导出合并数据"> </el-switch>
                <i class="el-icon-setting" slot="reference" style="padding-right: 10px; color: rgb(64, 158, 255)" />
              </el-popover>
              <el-button type="primary" plain @click="exportTrade()">导出订单</el-button>
            </template>
            <el-popover v-else placement="top-start" width="220" trigger="click" title="选择导出内容：">
              <el-button type="text" @click="exportTrade()">导出全部信息</el-button>
              <el-button type="text" @click="exportTrade('express')">导出快递信息</el-button>
              <el-button type="primary" plain slot="reference">导出订单</el-button>
            </el-popover>
            <el-upload
              ref="uploadXls"
              accept=".xls,.xlxs"
              :action="xlsData.uploadUrl"
              :show-file-list="false"
              :headers="xlsData.headers"
              :on-success="uploadXlsSuccess"
              :multiple="false"
              :on-error="uploadXlsError"
              v-if="queryParam.source == 'proxy'"
            >
              <el-button type="warning" plain>导入快递</el-button>
            </el-upload>
            <span style="margin-left: 20px">
              客户：{{ (queryParam.status == 'taked' && payTypes.length > 0 ? filterStatistics : statistics).purchaserIDs.length }}
            </span>
            <span style="margin-left: 20px">
              双数：{{ (queryParam.status == 'taked' && payTypes.length > 0 ? filterStatistics : statistics).total }}
            </span>
            <span v-if="queryParam.status == 'waitTake'" style="margin-left: 20px">
              待收：{{
                (queryParam.status == 'taked' && payTypes.length > 0 ? filterStatistics : statistics).receivePayment | decimalFormat
              }}
            </span>
            <span v-else style="margin-left: 20px">
              已收：{{
                (queryParam.status == 'taked' && payTypes.length > 0 ? filterStatistics : statistics).receivedPayment | decimalFormat
              }}
            </span>
          </div>
        </el-footer>
      </el-container>
      <div class="pay-type" v-if="queryParam.status == 'taked'">
        <div :class="payTypes.includes('wechat') ? 'is-active' : ''" @click="filterPayType('wechat')">
          <span class="wechat"><img src="/static/img/wechat.png" /></span>已转微信
        </div>
        <div :class="payTypes.includes('alipay') ? 'is-active' : ''" @click="filterPayType('alipay')">
          <span class="alipay"><img src="/static/img/alipay.png" /></span>已转支付宝
        </div>
        <div :class="payTypes.includes('cash') ? 'is-active' : ''" @click="filterPayType('cash')">
          <span class="cash"><img src="/static/img/cash.png" /></span>已转现金
        </div>
        <div :class="payTypes.includes('credit') ? 'is-active' : ''" @click="filterPayType('credit')">
          <span class="credit"><img src="/static/img/credit.png" /></span>欠款
        </div>
        <div :class="payTypes.includes('part') ? 'is-active' : ''" @click="filterPayType('part')" v-if="queryParam.source != 'proxy'">
          <span class="part-take"><img src="/static/img/part.png" /></span>货未提完
        </div>
        <div :class="payTypes.includes('refund') ? 'is-active' : ''" @click="filterPayType('refund')" v-if="queryParam.source != 'proxy'">
          <span class="refund"><img src="/static/img/refund.png" /></span>有退货
        </div>
      </div>
    </el-main>
    <el-aside width="610px">
      <cashier-detail
        ref="detail"
        :source="queryParam.source"
        :dateRange="dateRange"
        :status="queryParam.status"
        :storeID="queryParam.storeID"
        @refreshTrade="refreshTrade"
        @refresh="getList(true)"
        @changeSendLoading="changeSendLoading"
      />
    </el-aside>
    <add-refund ref="addRefund" @handleAddSuccess="getList()"></add-refund>
    <mul-check-export ref="mulCheckDlg" />
    <helper-center ref="helperCenter" position="cashier" :visible="true"></helper-center>
    <detail-content
      ref="detail2"
      :source="queryParam.source"
      :dateRange="dateRange"
      :status="queryParam.status"
      @refreshTrade="refreshTrade2"
      style="position: absolute; top: 0; left: 0; z-index: -100; width: 600px; height: 660px"
    />
    <stall-config
      ref="batchPrintConfigLoader"
      :field.sync="configField"
      :value.sync="printConfig"
      :dialog="false"
      :level="0"
      source="cashier"
      view-tab="bill"
      style="display: none"
    ></stall-config>

    <trade-print
      ref="batchTradePrint"
      print-view-tab="bill"
      :print-config.sync="printConfig"
      print-source="cashier"
      style="display: none"
    ></trade-print>
  </el-container>
</template>

<script>
import { submit } from '@/api/base'
import { baseURL } from '@/config'
import { getDate, getDatePickerOptions } from '@/utils/tool'
import CashierDetail from '@/views/stall/trade/cashier/components/cashierDetail.vue'
import AddRefund from '@/views/stall/trade/cashier/components/AddRefund.vue'
import HelperCenter from '@/views/stall/trade/components/HelperCenter.vue'
import DetailContent from './components/cashierDetailContent.vue'
import MulCheckExport from '@/views/stall/trade/components/MulCheckExport.vue'
import StallConfig from '@/views/stall/trade/components/StallConfig.vue'
import TradePrint from '@/views/stall/trade/components/TradePrint.vue'
import { botSend } from '@/utils/stallBot'
import { sassFalse } from 'sass'

export default {
  name: 'stallCashierIndex',
  props: {
    productIds: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  watch: {
    $route: {
      handler: 'setPageQuery',
    },
  },
  created() {
    this.setPageQuery()
  },
  components: {
    AddRefund,
    CashierDetail,
    HelperCenter,
    DetailContent,
    MulCheckExport,
    TradePrint,
    StallConfig,
  },
  data() {
    return {
      percentageShow: false,
      sendPercentage: 0,
      sendingFlag: false,
      printingFlag: false,
      noticeFlag: false,
      sendMsg: '',
      noticeText: '',
      sendTrades: [],
      popoverVisible: false,
      allSelect: false,
      listLoading: false,
      otherDateRange: '',
      dateRange: '',
      datePickerOptions: getDatePickerOptions(),
      encryptView: false,
      stores: [],
      queryParam: {
        source: '',
        storeID: 0,
        status: 'waitTake',
        startTime: null,
        endTime: null,
        searchValue: null,
        receivePayment: null,
        barcode: null,
        isMerge: true,
        ProductIds: '',
      },
      exportIsMerge: true,
      exportSpec: true,
      trades: [],
      onTrades: [],
      onTrades2: [],
      statistics: {
        total: 0,
        purchaserIDs: [],
        receivePayment: 0,
        receivedPayment: 0,
      },
      filterStatistics: {},
      payTypes: [],
      xlsData: {
        loading: false,
        uploadUrl: `${baseURL}/api/stall/proxy/importExpress`,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters['user/accessToken'],
        },
      },
      printConfig: {},
      configField: {},
      listSort: '',
      takedListSort: '',
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.$nextTick(async () => {
      this.filterStatistics = { ...this.statistics }
      if (this.$store.state.routes.systemSetting.MultiStore) {
        await this.getStores()
      }
      // 获取查询参数
      const productIds = this.productIds
      if (productIds) {
        this.queryParam.ProductIds = productIds
      } else {
        const today = getDate()
        this.dateDebtRange = [today, today]
        this.otherDateRange = [today, today]
        this.dateRange = [today, today]
      }
      this.init()
      this.getList()
      this.$refs.barcode?.focus()
    })
  },
  beforeDestroy() {
    // 销毁前移除监听，防止内存泄漏
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    /** 初始化批量打印配置，加载打印配置参数 */
    async init() {
      await this.$refs.batchPrintConfigLoader.getConfig()
      this.listSort = this.printConfig.bill.list.listSort
      this.takedListSort = this.printConfig.bill.list.takedListSort
    },
    async changeListSort() {
      if (this.queryParam.status != 'taked') {
        this.listSort = this.listSort == 'receivePaymentDesc' ? 'timeAsc' : 'receivePaymentDesc'
        this.printConfig.bill.list.listSort = this.listSort
      } else {
        this.takedListSort = this.takedListSort == 'modifyTimeAsc' ? 'modifyTimeDesc' : 'modifyTimeAsc'
        this.printConfig.bill.list.takedListSort = this.takedListSort
      }
      await this.$refs.batchPrintConfigLoader.saveConfig()
      await this.getList()
    },
    /** 批量发送选中报单的截图，逐条生成图片并推送，完成后显示进度与结果提示 */

    async handleSendPics() {
      this.sendingFlag = true
      const trades = this.trades.filter(item => item['newCheck'])
      if (trades.length == 0) {
        this.$baseMessage('请选择要发送截图的报单', 'error')
        this.sendingFlag = false
        return
      }
      this.sendPercentage = 0
      this.percentageShow = true
      const tradesLength = trades.length
      let currentCount = 0
      for (const trade of trades) {
        this.onTrades2 = [trade]
        await this.getDetails2()
        const res = await this.$refs.detail2.createImage('multiple')
        if (!res) {
          trade['picSendErr'] = true
        }
        currentCount++
        this.handleSetPercentage(currentCount, tradesLength)
      }
      this.$baseMessage('批量发送截图已完成', 'success')
      this.sendingFlag = false
      this.percentageShow = false
      this.$forceUpdate()
    },
    handleSetPercentage(currentCount, total) {
      this.sendPercentage = Math.ceil((currentCount / total) * 100)
    },
    async getDetails2() {
      await this.$refs.detail2.fetchData({
        onTrades: this.onTrades2,
        debtInfo: null,
      })
    },
    refreshTrade2(data) {
      this.onTrades2[0].TakeNum = data.TakeNum
      this.onTrades2[0].RefundNum = data.RefundNum
      this.onTrades2[0].ReceivePayment = data.RestPayment
      this.onTrades2[0].ReceivedPayment = data.ReceivedPayment
    },
    handleNewCheckToggle() {
      this.$forceUpdate()
    },
    handleAllToggle() {
      if (this.trades.length == 0) return
      for (let item of this.trades) {
        item['newCheck'] = this.allSelect ? true : false
      }
    },
    changeStore() {
      this.getList()
    },
    async getStores() {
      const { data } = await submit('/api/common/getStoreInfoList')
      if (typeof data != 'undefined' && data.length > 0) {
        this.stores = data
        let findItem = data.find(x => x.DefaultFlag)
        if (findItem) {
          this.queryParam.storeID = findItem.ID
        }
      }
    },
    setPageQuery() {
      let arr = this.$route.fullPath.split('/')
      this.queryParam.status = 'waitTake'
      if (['trade', 'proxy'].some(t => t == arr[arr.length - 1])) {
        this.queryParam.source = arr[arr.length - 1]
        if (this.queryParam.source == 'proxy') {
          this.queryParam.isMerge = false
        } else {
          this.queryParam.isMerge = true
        }
      }
    },
    resetQuery() {
      this.queryParam.searchValue = null
      this.queryParam.receivePayment = null
      this.queryParam.barcode = null
      this.getList()
    },
    initData() {
      this.trades = []
      this.$refs.detail.resetData()
      this.onTrades = []
      this.statistics = {
        total: 0,
        purchaserIDs: [],
        receivePayment: 0,
        receivedPayment: 0,
      }
    },
    getPurchaserClass(trade) {
      let classes = ['purchaser']
      if (trade.Num > trade.TakeNum) {
        classes.push('out-stock-num')
      }
      if (trade.IsProxy) {
        classes.push('proxy')
      }
      if (trade.RefundNum > 0) {
        classes.push('refund')
      } else if (trade.TakeStatus == 1) {
        classes.push('split')
      }
      if (this.queryParam.status == 'taked') {
        classes.push(this.getPayType(trade))
      }
      return classes.join(' ')
    },
    changeTab(tab) {
      if (tab.name == this.queryParam.status) {
        return
      }
      this.queryParam.status = tab.name
      let tempDateRange = this.dateRange
      this.dateRange = this.otherDateRange
      this.otherDateRange = tempDateRange
      this.getList()
    },
    changeEncrypt() {
      this.encryptView = !this.encryptView
      this.getList()
    },
    getQueryParam() {
      let param = { ...this.queryParam }
      if (this.encryptView) {
        param.startTime = null
        param.endTime = null
        param.searchValue = null
        param.receivePayment = null
      } else {
        param.startTime = this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : null
        param.endTime = this.dateRange && this.dateRange.length > 1 ? this.dateRange[1] : null
        param.barcode = null
      }
      return param
    },
    async getList(keepSelect = false) {
      let selectTrades = keepSelect && this.onTrades.length > 0 ? this.onTrades : null
      this.initData()
      if (this.encryptView && !this.queryParam.barcode) {
        this.$nextTick(async () => {
          this.$refs.barcode.focus()
        })
        return
      }
      this.listLoading = true
      const { data } = await submit('/api/stallCashier/getList', this.getQueryParam())
      this.listLoading = false
      if (this.encryptView && this.queryParam.barcode) {
        this.queryParam.barcode = null
        this.$refs.barcode.focus()
      }
      this.trades = data
      let purchaserIds = []
      this.trades.forEach(trade => {
        purchaserIds.push(trade.PurchaserID)
        this.statistics.total += trade.TakeNum - trade.RefundNum
        this.statistics.receivePayment += trade.ReceivePayment
        this.statistics.receivedPayment += trade.ReceivedPayment
      })
      this.statistics.purchaserIDs = [...new Set(purchaserIds)]
      if (this.encryptView) {
        if (this.trades.length > 0) {
          this.selectTrade(this.trades[0])
        }
      } else {
        this.keepSelectTrade(selectTrades)
      }
    },
    keepSelectTrade(selectTrades = null) {
      let tempTrade = null
      let total = 0
      let receivePayment = 0
      let receivedPayment = 0
      let purchaserIds = []
      for (let trade of this.trades) {
        trade.LastPayType = this.getPayType(trade)
        if (this.queryParam.status == 'taked') {
          trade.Hidden = this.payTypes.length > 0
          for (let type of this.payTypes) {
            if ((type == 'part' && trade.TakeStatus == 1) || (type == 'refund' && trade.RefundNum != 0) || trade.PayType.includes(type)) {
              trade.Hidden = false
              total += trade.TakeNum - trade.RefundNum
              receivePayment += trade.ReceivePayment
              receivedPayment += trade.ReceivedPayment
              purchaserIds.push(trade.PurchaserID)
              break
            }
          }
        }
        trade.Selected = false
        if (trade.Hidden) {
          continue
        }
        if (selectTrades && selectTrades.some(t => t.TradeIDs == trade.TradeIDs)) {
          tempTrade = trade
        }
      }
      if (this.queryParam.status == 'taked' && this.payTypes.length > 0) {
        this.filterStatistics.total = total
        this.filterStatistics.receivePayment = receivePayment
        this.filterStatistics.receivedPayment = receivedPayment
        this.filterStatistics.purchaserIDs = [...new Set(purchaserIds)]
      }
      if (tempTrade) {
        this.selectTrade(tempTrade)
      }
    },
    selectTrade(selectTrade) {
      this.onTrades = []
      selectTrade.Selected = !selectTrade.Selected
      for (let trade of this.trades) {
        if (trade.PurchaserID != selectTrade.PurchaserID) {
          trade.Selected = false
        } else if (this.queryParam.source == 'proxy' && selectTrade.TradeIDs != trade.TradeIDs) {
          trade.Selected = false
        }
        if (trade.Selected) {
          this.onTrades.push(trade)
        }
      }
      this.$forceUpdate()
      this.getDetails()
    },
    getPayType(trade) {
      if (trade.PayType && trade.PayType.includes('credit')) {
        return 'credit'
      }
      let payTypes = trade.PayType ? trade.PayType.split(',') : []
      return payTypes.length > 0 ? payTypes[payTypes.length - 1] : ''
    },
    filterPayType(payType) {
      let select = true
      for (let i = 0; i < this.payTypes.length; i++) {
        if (this.payTypes[i] == payType) {
          select = false
          this.payTypes.splice(i, 1)
          break
        }
      }
      if (select) {
        this.payTypes.push(payType)
      }
      this.keepSelectTrade(this.onTrades ? this.onTrades : null)
      this.$forceUpdate()
    },
    refreshTrade(data) {
      this.onTrades[0].TakeNum = data.TakeNum
      this.onTrades[0].RefundNum = data.RefundNum
      this.onTrades[0].ReceivePayment = data.RestPayment
      this.onTrades[0].ReceivedPayment = data.ReceivedPayment
    },
    async getDetails() {
      this.$refs.detail.fetchData({
        onTrades: this.onTrades,
        debtInfo: null,
      })
    },
    changeSendLoading(value) {
      this.sendingFlag = value
    },
    async showAddRefund() {
      this.$refs.addRefund.init(null, 0, this.$store.state.routes.systemSetting.MultiStore ? this.queryParam.storeID : null)
    },
    async exportTrade(type = 'all') {
      let tradeIDs = []
      let refundIDs = []
      this.trades
        .filter(item => item['newCheck'])
        .forEach(trade => {
          if (trade.TradeIDs) {
            tradeIDs.push(trade.TradeIDs)
          }
          if (trade.RefundIDs) {
            refundIDs.push(trade.RefundIDs)
          }
        })
      var param = {
        ...this.getQueryParam(),
        tradeIDs: tradeIDs.join(','),
        refundIDs: refundIDs.join(','),
        Type: type,
        ExportIsMerge: this.exportIsMerge,
        exportSpec: this.exportSpec,
      }
      let colCheckList = [
        { label: '单据类型', value: 'BillType', IsMerge: true, disabled: false, isDefaultCheck: true },
        { label: '客户', value: 'PurchaserName', IsMerge: true, mergeKeys: ['BillType'], disabled: true, isDefaultCheck: true },
        { label: '订单号', value: 'Tid', IsMerge: true, mergeKeys: ['BillType', 'PurchaserName'], CLen: 30, isDefaultCheck: true },
        {
          label: '报单时间',
          value: 'CreateTime',
          type: 'datetime',
          IsMerge: true,
          CLen: 25,
          mergeKeys: ['BillType', 'PurchaserName', 'Tid'],
          isDefaultCheck: true,
        },
        {
          label: '提货时间',
          value: 'TakeTime',
          type: 'datetime',
          IsMerge: true,
          CLen: 25,
          mergeKeys: ['BillType', 'PurchaserName', 'Tid'],
          isDefaultCheck: true,
        },
        {
          label: '总金额',
          value: 'Payment',
          type: 'decimal',
          IsMerge: true,
          mergeKeys: ['BillType', 'PurchaserName', 'Tid'],
          isDefaultCheck: true,
        },
        {
          label: '总数量',
          value: 'Num',
          type: 'int',
          IsMerge: true,
          mergeKeys: ['BillType', 'PurchaserName', 'Tid'],
          isDefaultCheck: true,
        },
        {
          label: '商品货号',
          value: 'ItemNo',
          IsMerge: true,
          mergeKeys: ['BillType', 'PurchaserName', 'Tid'],
          isDefaultCheck: true,
          disabled: true,
        },
      ]
      if (this.exportSpec) {
        colCheckList.push({ label: '规格名称', value: 'SpecName', isDefaultCheck: true })
        colCheckList.push({ label: '颜色', value: 'Color' })
        colCheckList.push({ label: '尺码', value: 'Size' })
        colCheckList.push({ label: '商品单价', value: 'ItemPrice', type: 'decimal', isDefaultCheck: true })
      }
      colCheckList.push({ label: '数量', value: 'ItemNum', type: 'int', isDefaultCheck: true, disabled: true })
      colCheckList.push({ label: '商品金额', value: 'ItemTotal', type: 'decimal', isDefaultCheck: true })
      if (param.Status == 'taked') {
        colCheckList.push({
          label: '支付方式',
          value: 'PayType',
          type: 'string',
          IsMerge: true,
          mergeKeys: ['BillType', 'PurchaserName', 'Tid'],
          isDefaultCheck: true,
        })
      }
      this.$refs.mulCheckDlg.init(param, colCheckList, param.source, type)
    },
    uploadXlsSuccess(res) {
      if (res.msg) {
        this.$message({ type: 'error', message: '导入错误：' + res.msg })
      } else {
        this.$message({ type: 'success', message: '导入成功，' + res.data })
      }
      this.$refs.uploadXls.clearFiles()
      this.xlsData.loading = false
      this.getList()
    },
    uploadXlsError() {
      this.$message({ type: 'error', message: '导入失败' })
      this.xlsData.loading = false
    },
    async handleBatchPrint() {
      await this.$refs.batchPrintConfigLoader.getConfig()
      if (this.printingFlag) return

      const trades = this.trades.filter(item => item.newCheck)
      if (trades.length === 0) {
        this.$baseMessage('请选择要打印的订单', 'error')
        return
      }

      this.printingFlag = true

      let printViewContainer = document.getElementById('print-view')
      if (!printViewContainer) {
        printViewContainer = document.createElement('div')
        printViewContainer.id = 'print-view'
        printViewContainer.style.display = 'none'
        document.body.appendChild(printViewContainer)
      }

      try {
        await this.$refs.batchTradePrint.init()

        const batchContainer = document.createElement('div')

        let startTime = this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : null //筛选开始时间
        let endTime = this.dateRange && this.dateRange.length > 1 ? this.dateRange[1] : null //筛选结束时间

        for (const trade of trades) {
          const paperBillEl = document.querySelector('#print-view .paper-bill')
          if (paperBillEl) paperBillEl.innerHTML = ''

          await this.$refs.batchTradePrint.getPrintInfo(
            trade.TradeIDs || '',
            trade.RefundIDs || '',
            null,
            null,
            this.queryParam.status === 'taked' ? 1 : 0,
            null, //batchNos
            '', //sortField
            startTime, //筛选开始时间
            endTime //筛选结束时间
          )

          const paperBill = document.querySelector('#print-view .paper-bill')
          if (paperBill && paperBill.innerHTML.trim()) {
            const clone = paperBill.cloneNode(true)
            clone.style.pageBreakAfter = 'always'
            batchContainer.appendChild(clone)
            paperBill.innerHTML = ''
          }
        }

        if (batchContainer.children.length === 0) {
          this.$baseMessage('无可打印内容', 'warning')
          return
        }

        const htmlContent = batchContainer.innerHTML

        const printHtml =
          '<!DOCTYPE html>\n' +
          '<html>\n' +
          '<head>\n' +
          '<meta charset=" "utf-8">\n' +
          '<title>云果仓</title>\n' +
          '<style>\n' +
          'body { margin: 0; padding: 0; background: white; }\n' +
          '#print-content { width: 80mm;}\n' +
          '@media print {\n' +
          'body { -webkit-print-color-adjust: exact; color-adjust: exact; }\n' +
          '#print-content > div { page-break-after: always; }\n' +
          '#print-content > div:last-child { page-break-after: auto; }\n' +
          '}\n' +
          '</style>\n' +
          '</head>\n' +
          '<body>\n' +
          '<div id="print-content">' +
          htmlContent +
          '</div>\n' +
          '</body>\n' +
          '</html>'
        const iframe = document.createElement('iframe')
        iframe.style.cssText = 'position: fixed; top: -9999px; left: -9999px; width: 0; height: 0; border: none;'
        document.body.appendChild(iframe)

        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
        iframeDoc.open()
        iframeDoc.write(printHtml)
        iframeDoc.close()
        let printed = false
        const doPrint = () => {
          if (printed) return
          printed = true

          try {
            iframe.contentWindow.focus()
            iframe.contentWindow.print()
          } catch (e) {
            console.warn('打印异常', e)
          }

          setTimeout(() => {
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
          }, 2000)
        }

        iframe.onload = doPrint
        setTimeout(doPrint, 500)

        this.$baseMessage(`已生成 ${trades.length} 张小票，请在打印预览中点击“打印”`, 'success')
      } catch (err) {
        console.error('批量打印失败', err)
        this.$baseMessage('打印失败：' + (err.message || '未知错误'), 'error')
      } finally {
        this.printingFlag = false
      }
    },
    handleClickOutside(event) {
      if (!this.popoverVisible) return

      // 获取 Popover  DOM 元素和触发元素
      const popoverEl = this.$refs.myPopover.$el
      const triggerEl = this.$el.querySelector('.sendNoticeBtn')

      // 如果点击的目标不在 Popover 内，也不在触发元素上，则关闭
      if (popoverEl && !popoverEl.contains(event.target) && triggerEl && !triggerEl.contains(event.target)) {
        this.popoverVisible = false
      }
    },

    async sendNotice() {
      let that = this
      if (!that.sendMsg) {
        this.$baseMessage('请输入缺货通知内容', 'error')
        return
      } else {
        try {
          if (that.noticeFlag) return
          that.noticeFlag = true
          let sendCount = 0
          for (var k = 0; k < that.sendTrades.length; k++) {
            const item = that.sendTrades[k]
            if (item.PurchaserQQ && item.PurchaserBotUid) {
              let res = await botSend('text', that.sendMsg, {
                botType: item.PurchaserBotType,
                botUid: item.PurchaserBotUid,
                senderUid: item.PurchaserQQ,
              })
              if (res) {
                sendCount++
              }
            }
          }
          if (sendCount > 0) {
            this.$baseMessage(`发送成功`, 'success')
          }
        } catch (err) {
          console.error('批量缺货通知失败', err)
          this.$baseMessage('缺货通知失败：' + (err.message || '未知错误'), 'error')
        } finally {
          this.noticeFlag = false
          this.popoverVisible = false
        }
      }
    },
    async handleBatchNotice() {
      await this.$refs.batchPrintConfigLoader.getConfig()
      if (this.noticeFlag) return
      event.stopPropagation()
      if (!this.popoverVisible) {
        this.sendTrades = this.trades.filter(item => item.newCheck)
        if (this.sendTrades.length === 0) {
          this.sendTrades = this.trades.filter(item => 1 == 1)
          if (this.sendTrades.length === 0) {
            this.$baseMessage('请选择要缺货通知的订单', 'error')
            return
          }
        }
        this.sendTrades = this.sendTrades.filter(item => item.TakeNum == 0 && item.PurchaserQQ && item.PurchaserBotUid)
        if (this.sendTrades.length === 0) {
          this.$baseMessage('所选订单不满足缺货通知条件，无法发送。', 'error')
          return
        }
        let that = this
        that.sendMsg = that.printConfig.bill.list.stockoutNotice
        that.popoverVisible = true
      } else {
        this.popoverVisible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin trade-icon {
  position: absolute;
  height: 28px;
  width: 28px;
  border-radius: 14px;
  opacity: 0.9;

  img {
    height: 16px;
    width: 16px;
  }
}

.cash-register-main {
  min-width: 1760px;

  .trade-main {
    height: 100%;
    border-radius: 7px;

    & > header {
      position: relative;

      .el-form {
        position: absolute;
        left: 230px;
        top: 0;
        width: calc(100% - 230px);

        .el-select {
          width: 100px;
          margin-right: 5px;
        }

        .date-range {
          width: 210px;

          ::v-deep {
            .el-range-input {
              width: 70px;
            }
          }
        }

        .search-item {
          width: 85px !important;
        }

        .barcode {
          width: 45px !important;
          margin-right: 5px;

          &.encrypt {
            width: 200px !important;
            max-width: 250px;
          }
        }

        .el-button {
          width: 68px;
        }

        ::v-deep {
          .el-range-editor {
            &.el-input__inner {
              padding: 3px 0 0 5px;
            }

            .el-range-separator {
              width: auto;
            }

            .el-range__close-icon {
              width: 5px;
            }
          }

          .el-form-item__label {
            padding-right: 0;
          }

          .el-form-item {
            margin-right: 8px;
          }

          .el-input__inner {
            padding: 3px 0 0 5px;
          }
        }
      }

      ::v-deep {
        .el-radio-button__inner {
          font-size: 14px;
        }

        .unmerge-show .el-switch__label {
          right: -5px !important;
          text-align: right;
        }
      }

      .merge-show,
      .unmerge-show {
        ::v-deep {
          .el-switch__label {
            position: absolute;
            top: 0;
            left: 3px;
            z-index: 3;
            color: #ffffff;
          }

          .el-switch__core {
            width: 52px !important;
          }
        }
      }
    }

    .trade-list-main {
      padding: 10px 5px 0 5px;
      border-top: unset !important;
    }

    .trade-list {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      flex-flow: wrap;
      justify-content: left;
      overflow-y: auto;
      position: relative;

      .trade {
        display: inline-block;
        width: 120px;
        height: 105px;
        font-size: 14px;
        font-weight: bold;
        border-radius: 5px;
        color: #303133;
        cursor: pointer;
        background-color: #f3f7f9;
        border: solid 2px #d2dadf;
        position: relative;
        overflow: hidden;
        margin: 0 5px 5px 0;

        &.is-active {
          background-color: #e9f4ff;
          border-color: #409eff;
        }

        &.multi {
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 1px;
            border-right: solid 1px #d2dadf;
            border-bottom: solid 1px #d2dadf;
          }

          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 4px;
            border-right: solid 1px #d2dadf;
            border-bottom: solid 1px #d2dadf;
          }
        }

        ::v-deep {
          .el-card__header,
          .el-card__body {
            padding: 5px;
            position: relative;

            & > div {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              box-sizing: border-box;
              min-height: 20px;
            }
          }
        }

        .purchaser {
          text-align: center;

          &.out-stock-num {
            color: #f44a4a;
          }

          &::before {
            content: '';
            position: absolute;
            box-sizing: border-box;
            top: 0px;
            left: 0px;
            width: 20px;
            height: 20px;
            background-size: 20px;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 10px;
          }

          &::after {
            content: '';
            position: absolute;
            box-sizing: border-box;
            top: 0px;
            right: 0px;
            width: 20px;
            height: 20px;
            background-size: 16px;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 10px;
          }

          &.proxy {
            &::before {
              content: '代';
              color: #fff;
              background-color: #0075e3;
              width: 22px;
              height: 22px;
            }
          }

          &.split {
            &::before {
              background-image: url('/static/img/part.png');
            }
          }

          &.refund {
            &::before {
              background-image: url('/static/img/refund.png');
            }
          }

          &.credit {
            &::after {
              background-color: #f44a4a;
              background-image: url('/static/img/credit.png');
            }
          }

          &.alipay {
            &::after {
              background-color: #409eff;
              background-image: url('/static/img/alipay.png');
            }
          }

          &.wechat {
            &::after {
              background-color: #67c23a;
              background-image: url('/static/img/wechat.png');
            }
          }

          &.cash {
            &::after {
              background-color: #e6a23c;
              background-image: url('/static/img/cash.png');
            }
          }
        }

        .create-time {
          font-weight: normal;
        }
      }

      .trade.is-active {
        background-color: #e9f4ff;
        border-color: #409eff;
      }
    }

    & > footer {
      text-align: right;
      font-size: 18px;
      font-weight: bold;
      line-height: 40px;

      & > div {
        display: inline-flex;
        vertical-align: middle;
        margin-left: 10px;
      }

      & > span {
        margin-left: 20px;
        display: inline-flex;
        vertical-align: middle;
      }

      & > i {
        margin-left: 20px;
        vertical-align: middle;
      }
    }
  }

  main {
    position: relative;
    overflow-x: hidden;

    .pay-type {
      position: absolute;
      top: 90px;
      right: -72px;

      &:hover {
        right: 0px;
      }

      div {
        border: 1px solid #409eff;
        border-radius: 20px;
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        padding: 3px 3px 3px 5px;
        cursor: pointer;
        background: #fff;

        &.is-active {
          background: #dbedff;
        }
      }

      div:not(:first-child) {
        border-top: none;
      }

      span {
        height: 25px;
        width: 25px;
        display: inline-block;
        border-radius: 15px;
        vertical-align: middle;
        text-align: center;
        margin-right: 3px;

        &.wechat {
          background: #67c23a;
        }

        &.alipay {
          background: #409eff;
        }

        &.cash {
          background: #e6a23c;
        }

        &.credit {
          background: #f44a4a;
        }

        &.part-take {
          border: 1px solid #6c57f0;
        }

        &.refund {
          border: 1px solid #f44a4a;
        }
      }

      img {
        display: inline-block;
        height: 20px;
        width: 20px;
        margin-top: 3px;
      }
    }
  }
}

.el-popover.errPopper {
  width: 92px !important;
  min-width: 0 !important;
  text-align: center;
}

.sort-icon {
  font-size: 22px;
  font-weight: normal;
  margin: 0 6px 0 3px;
  cursor: pointer;

  &::before {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: middle;
  }

  &.order-active-desc::before {
    background-image: url('~@/assets/img/home/active_time_asc.png');
  }

  &.order-inactive-desc::before {
    background-image: url('~@/assets/img/home/inactive_time_asc.png');
  }

  &.taked-order-active-desc::before {
    background-image: url('~@/assets/img/home/taked_active_time_desc.png');
  }

  &.taked-order-inactive-desc::before {
    background-image: url('~@/assets/img/home/taked_inactive_time_desc.png');
  }
}
</style>
